import { Reducer } from 'redux';
import { AtendimentosState, AtendimentosTypes } from './types';

const INITIAL_STATE: AtendimentosState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  sorter: undefined,

  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<AtendimentosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AtendimentosTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AtendimentosTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
        ordenacao: action.payload.ordenacao,
      };
    case AtendimentosTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case AtendimentosTypes.FILTER_ATENDIMENTOS:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case AtendimentosTypes.SORTER_ATENDIMENTOS:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case AtendimentosTypes.CLEAN_ATENDIMENTOS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
